import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AccessControlButtonProps } from '../../Interfaces/Props';
import { IRootState } from '../../Storage/Redux/store';
import { TblRouteStore } from '../../Interfaces/DataBase';

function AccessControlButton(props: AccessControlButtonProps) {
  const navigate = useNavigate();
  const allRouteData = useSelector((r: IRootState) => r.routesStore);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (props.path) {
      setShow(
        allRouteData.some((route: TblRouteStore) => {
          if (!route.routePath) return false;

          let escapedRoutePath = route.routePath;
          escapedRoutePath = escapedRoutePath.replace(
            /\/:(\w+)\?/g,
            '(/[^/]+)?'
          );
          escapedRoutePath = escapedRoutePath.replace(/\/:(\w+)/g, '(/[^/]+)');

          const regex = new RegExp(`^${escapedRoutePath}$`);
          return regex.test(props.path!);
        })
      );
    } else {
      setShow(true);
    }
  }, [allRouteData, props.path]);

  if (show) {
    return (
      <button
        className={props.className}
        onClick={() => {
          if (props.path) {
            navigate(props.path);
          }
          if (props.onClick) {
            props.onClick();
          }
        }}
      >
        {props.children!}
      </button>
    );
  } else {
    return <></>;
  }
}

export default AccessControlButton;
